import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styles from './NavBar.module.css';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { IconLoader } from 'common/IconLoader';
import { logout } from 'redux/actions';
import { withAuth } from 'components/shared/Auth';
import UserProfile from './UserProfile/UserProfile';

const NavHoverMenu = (props) => {
  return (
    <div
      className={classNames({ [styles.NavHoverMenu_FixedWrapper]: true, [styles.NavHoverMenu_Hidden]: props.hidden })}
    >
      <div className={classNames({ [styles.NavHoverMenu_OuterDiv]: true })}>
        {React.Children.map(props.children, (child) => {
          return <div className={styles.NavHoverMenu_InnerDiv}>{child}</div>;
        })}
      </div>
    </div>
  );
};

class NavIconAndText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hovered: false
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.showMenu && !this.props.showMenu) {
      this.setState({ hovered: false });
    }
  }

  render() {
    return (
      <div
        className={classNames({
          [styles.iconAndText]: true
        })}
        onClick={this.props.onClick}
        onMouseEnter={() => this.setState({ hovered: true })}
        onMouseLeave={() => {
          this.setState({ hovered: false });
          if (this.props.onMouseLeave) {
            this.props.onMouseLeave();
          }
        }}
      >
        <SvgAF
          img={this.props.img}
          hover={this.props.hoverImg}
          forceHover={this.state.hovered || this.props.isCurrent}
          tooltip={this.props.tooltip}
        />
        <span
          className={classNames({
            [styles.iconText]: true,
            [styles.iconTextHidden]: !this.props.expanded,
            [styles.selectedText]: this.props.isCurrent
          })}
        >
          {this.props.text}
        </span>
        <div className={styles.iconAndTextPlaceHolder}>{this.props.showMenu ? this.props.hoverMenu : null}</div>
      </div>
    );
  }
}

/**
 * Pure Component: Navigation bar
 *
 * @module Generic Components
 * @type Pure Component
 * @file NavBar.js
 * @author Christophe Vidal
 *
 */
class NavBar extends Component {
  constructor() {
    super();
    this.state = {
      expanded: false,
      selectedIcon: null
    };

    this.compactRef = React.createRef();
    this.wideRef = React.createRef();
  }

  /**
   * Expand / Reduce the navigation bar pannel
   *
   */
  expandReduce = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  /**
   * logout: call the Auth0 logout method
   *
   * @method logout
   * @param none
   * @public
   *
   */
  logout = () => {
    this.props.history.push('/logout');
    this.props.auth.logout();
    this.props.dispatch(logout());
  };

  componentDidMount() {
    window.addEventListener('resize', () =>
      this.setState({})
    ); /* Rerender navbar on window resize to make sure it always fits*/
  }

  componentDidUpdate() {}

  changePasswordOnClick = (evt) => {
    this.setState({ selectedIcon: null });
    this.props.history.push('/console/change-password');
    evt.stopPropagation();
  };

  logoutOnClick = () => {
    this.logout();
  };

  render() {
    let height = window.innerHeight;

    let logo = this.state.expanded ? (
      <SvgAF key="1" img={IconLoader.icon_IBMS_wide} />
    ) : (
      <SvgAF key="2" img={IconLoader.icon_logo_IBMS_compact_fixed} />
    );

    if (this.prevExpanded == null) {
      this.prevExpanded = false;
      this.hide_logo = false;
    } else if (this.prevExpanded !== this.state.expanded) {
      this.hide_logo = true;
      setTimeout(() => {
        this.hide_logo = false;
        this.setState({});
      }, 200);
    }

    if (this.prevExpanded !== this.state.expanded) {
      this.prevExpanded = this.state.expanded;
    }

    return (
      <div className={styles.containerDiv}>
        <div>
          <div
            className={classNames({ [styles.navbar_compact]: true, [styles.navbar_expanded]: this.state.expanded })}
            style={{ height: height }}
            ref={this.compactRef}
          >
            <div
              className={classNames({ [styles.logo_div]: true, [styles.logo_div_hide]: this.hide_logo })}
              onClick={() => this.props.history.push('/console/devices')}
            >
              {logo}
            </div>
            <div className={styles.iconsGroup}>
              <div style={{ height: '32px' }} />
              <NavIconAndText
                img={IconLoader.icon_devices}
                expanded={this.state.expanded}
                hoverImg={IconLoader.icon_devices_hover}
                text={'Devices'}
                onClick={() => this.props.history.push('/console/devices')}
                isCurrent={this.props.page === 'DevicesPage' || this.props.page === 'SingleDevicePage'}
              />
              <NavIconAndText
                img={IconLoader.icon_actions}
                expanded={this.state.expanded}
                hoverImg={IconLoader.icon_actions_hover}
                text={'Actions'}
                onClick={() => this.props.history.push('/console/actions')}
                isCurrent={this.props.page === 'ActionsPage'}
              />
              {/* As a part of IBMS-5216 re are removing this section  */}
              {/* <NavIconAndText
                img={IconLoader.icon_monitor}
                expanded={this.state.expanded}
                hoverImg={IconLoader.icon_monitor_selected}
                text={'Monitor'}
                onClick={() => this.props.history.push('/console/monitor')}
                isCurrent={this.props.page === 'MonitorPage'}
              /> */}
              <NavIconAndText
                img={IconLoader.icon_chart_explorer_navbar}
                expanded={this.state.expanded}
                hoverImg={IconLoader.icon_chart_explorer_navbar_selected}
                text={'Chart Explorer'}
                onClick={() => this.props.history.push('/console/chart-explorer/detail')}
                isCurrent={this.props.page === 'ChartExplorerPage'}
              />
            </div>
            <div className={styles.iconsGroup + ' ' + styles.iconsBottom}>
              <NavIconAndText
                img={IconLoader.icon_admin}
                expanded={this.state.expanded}
                hoverImg={IconLoader.icon_admin_hover}
                text={'Admin'}
                onClick={() => this.props.history.push('/console/admin')}
                isCurrent={this.props.page === 'AdminPage'}
              />
              <NavIconAndText
                img={IconLoader.icon_user}
                expanded={this.state.expanded}
                hoverImg={IconLoader.icon_user_hover}
                text={this.props.userTag}
                onClick={() => {
                  this.setState({ selectedIcon: 'user' });
                }}
                hoverMenu={
                  <UserProfile changePasswordOnClick={this.changePasswordOnClick} logoutOnClick={this.logoutOnClick} />
                }
                showMenu={this.state.selectedIcon === 'user'}
                onMouseLeave={() => {
                  if (this.state.selectedIcon === 'user') {
                    this.setState({ selectedIcon: null });
                  }
                }}
                isCurrent={this.props.page === 'UserPage' || this.props.page === 'ChangePasswordPage'}
              />
              <div
                className={classNames({
                  [styles.ConsolePage_UserTag]: true,
                  [styles.ConsolePage_UserTag_Hidden]: this.state.expanded
                })}
              >
                {this.props.userTag}
              </div>
            </div>
            <div
              className={classNames({
                [styles.contractIconDiv]: this.state.expanded,
                [styles.expandIconDiv]: !this.state.expanded
              })}
              onClick={this.expandReduce}
            >
              <SvgAF img={IconLoader.icon_expand} hover={IconLoader.icon_expand_hover} />
            </div>
          </div>
        </div>
        <div
          className={classNames({
            [styles.placeholder_compact]: !this.state.expanded,
            [styles.placeholder_wide]: this.state.expanded
          })}
        />
      </div>
    );
  }
}

export default withAuth(
  withRouter(
    connect((store) => {
      return {
        page: store.page,
        userTag: store.data?.user?.userTag
      };
    })(NavBar)
  )
);
